import BrandedWatchLiveButton from './watch-live-button-brand'
import WatchLiveButton from './watch-live-button'

export {
  BrandedWatchLiveButton,
}

export default WatchLiveButton
